// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rulesGroupForm {
  color: #000;
}

.rulesInfoMessage {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 22px;
  padding: 14px 16px;
  border: 1px solid #cfd1d2;
  background: #f5f5f5;
  font-size: 13px;
  line-height: 1.5;
}

.rulesInfoMessage img {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-top: 1px;
}

.rulesInfoMessage p {
  margin: 0;
}

.rulesGroupFields {
  border-top: 1px solid #cfd1d2;
}

.rulesFieldSection {
  padding: 20px 0 22px;
  border-bottom: 1px solid #cfd1d2;
}

.rulesFieldHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.rulesFieldHeading {
  display: flex;
  align-items: flex-start;
  min-width: 0;
}

.rulesFieldHeading .MuiCheckbox-root {
  flex: 0 0 auto;
  margin: -5px 8px 0 0;
  padding: 4px;
}

.rulesCheckboxIcon {
  display: block;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 0;
  background: #71767c;
}

.rulesFieldTitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 700;
}

.rulesFieldText .rulesSelectAll {
  margin-top: 12px;
}

.rulesRequiredMark {
  margin-left: 4px;
  color: #e20015;
}

.rulesFieldDescription {
  margin: 3px 0 0;
  color: #4d4d4d;
  font-size: 12px;
  line-height: 1.4;
}

.rulesRequiredBadge {
  flex: 0 0 auto;
  padding: 5px 9px;
  background: #007bc0;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.rulesFieldHeaderActions {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
}

.rulesFieldBody {
  margin: 14px 0 0 36px;
}

.rulesSelectedValues {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 0;
  margin-bottom: 12px;
}

.rulesValueChip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 26px;
  padding: 3px 7px;
  border: 1px solid #cfd1d2;
  border-radius: 2px;
  background: #f1f1f1;
  font-size: 12px;
  line-height: 1.2;
}

.rulesValueChipAll {
  border-color: #007bc0;
  background: #d1e4ff;
  font-weight: 700;
}

.rulesValueChip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #000;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.rulesValueChip button:hover {
  color: #e20015;
}

.rulesFieldAddRow {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.rulesTextInput,
.rulesCenterAutocomplete {
  width: min(100%, 320px);
  min-width: 220px;
}

.rulesTextInput .MuiFormControl-root,
.rulesCenterAutocomplete .MuiFormControl-root {
  width: 100%;
}

.rulesCenterAutocomplete .MuiFilledInput-root {
  min-height: 50px;
  padding-top: 0;
  border-bottom: 1px solid #000;
  background: transparent;
}

.rulesCenterAutocomplete .MuiFilledInput-root::before,
.rulesCenterAutocomplete .MuiFilledInput-root::after {
  border-bottom-color: #000;
}

.rulesCenterAutocomplete .MuiInputBase-input {
  padding: 13px 12px;
  font-size: 14px;
}

.rulesAddButton {
  width: 120px;
  height: 50px;
  min-height: 50px;
  flex: 0 0 auto;
}

.rulesAddButton .imgIcone {
  margin-right: 0;
}

.rulesSelectAll {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  color: #4d4d4d;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.rulesSelectAll .MuiCheckbox-root {
  margin-right: 3px;
  padding: 4px;
}

.rulesCenterSearchError {
  margin: 8px 0 0;
  color: #e20015;
  font-size: 12px;
}

.rulesFieldError .containerErro {
  min-height: 32px;
  font-size: 12px;
}

.rulesSaveMessage {
  margin-top: 18px;
  padding: 10px 12px;
  border-left: 4px solid #00884a;
  background: #e5f4eb;
  color: #000;
  font-size: 13px;
}

.rulesFormActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 24px;
}

.rulesCancelButton,
.rulesSaveButton {
  min-width: 120px;
  min-height: 50px;
  justify-content: center;
}

@media (max-width: 700px) {
  .rulesFieldHeader {
    align-items: flex-start;
  }

  .rulesRequiredBadge {
    display: none;
  }

  .rulesFieldHeaderActions {
    display: none;
  }

  .rulesFieldBody {
    margin-left: 0;
  }

  .rulesTextInput,
  .rulesCenterAutocomplete {
    min-width: 100%;
  }

  .rulesAddButton,
  .rulesSelectAll {
    flex: 1 1 auto;
  }

  .rulesFormActions {
    justify-content: stretch;
  }

  .rulesCancelButton,
  .rulesSaveButton {
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentes/ConfigGrupos/regrasGrupoForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,SAAW;EACb;AACF","sourcesContent":[".rulesGroupForm {\n  color: #000;\n}\n\n.rulesInfoMessage {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 22px;\n  padding: 14px 16px;\n  border: 1px solid #cfd1d2;\n  background: #f5f5f5;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.rulesInfoMessage img {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n\n.rulesInfoMessage p {\n  margin: 0;\n}\n\n.rulesGroupFields {\n  border-top: 1px solid #cfd1d2;\n}\n\n.rulesFieldSection {\n  padding: 20px 0 22px;\n  border-bottom: 1px solid #cfd1d2;\n}\n\n.rulesFieldHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.rulesFieldHeading {\n  display: flex;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.rulesFieldHeading .MuiCheckbox-root {\n  flex: 0 0 auto;\n  margin: -5px 8px 0 0;\n  padding: 4px;\n}\n\n.rulesCheckboxIcon {\n  display: block;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  border-radius: 0;\n  background: #71767c;\n}\n\n.rulesFieldTitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.35;\n  font-weight: 700;\n}\n\n.rulesFieldText .rulesSelectAll {\n  margin-top: 12px;\n}\n\n.rulesRequiredMark {\n  margin-left: 4px;\n  color: #e20015;\n}\n\n.rulesFieldDescription {\n  margin: 3px 0 0;\n  color: #4d4d4d;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.rulesRequiredBadge {\n  flex: 0 0 auto;\n  padding: 5px 9px;\n  background: #007bc0;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.rulesFieldHeaderActions {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.rulesFieldBody {\n  margin: 14px 0 0 36px;\n}\n\n.rulesSelectedValues {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-height: 0;\n  margin-bottom: 12px;\n}\n\n.rulesValueChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 26px;\n  padding: 3px 7px;\n  border: 1px solid #cfd1d2;\n  border-radius: 2px;\n  background: #f1f1f1;\n  font-size: 12px;\n  line-height: 1.2;\n}\n\n.rulesValueChipAll {\n  border-color: #007bc0;\n  background: #d1e4ff;\n  font-weight: 700;\n}\n\n.rulesValueChip button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #000;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.rulesValueChip button:hover {\n  color: #e20015;\n}\n\n.rulesFieldAddRow {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.rulesTextInput,\n.rulesCenterAutocomplete {\n  width: min(100%, 320px);\n  min-width: 220px;\n}\n\n.rulesTextInput .MuiFormControl-root,\n.rulesCenterAutocomplete .MuiFormControl-root {\n  width: 100%;\n}\n\n.rulesCenterAutocomplete .MuiFilledInput-root {\n  min-height: 50px;\n  padding-top: 0;\n  border-bottom: 1px solid #000;\n  background: transparent;\n}\n\n.rulesCenterAutocomplete .MuiFilledInput-root::before,\n.rulesCenterAutocomplete .MuiFilledInput-root::after {\n  border-bottom-color: #000;\n}\n\n.rulesCenterAutocomplete .MuiInputBase-input {\n  padding: 13px 12px;\n  font-size: 14px;\n}\n\n.rulesAddButton {\n  width: 120px;\n  height: 50px;\n  min-height: 50px;\n  flex: 0 0 auto;\n}\n\n.rulesAddButton .imgIcone {\n  margin-right: 0;\n}\n\n.rulesSelectAll {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  color: #4d4d4d;\n  cursor: pointer;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.rulesSelectAll .MuiCheckbox-root {\n  margin-right: 3px;\n  padding: 4px;\n}\n\n.rulesCenterSearchError {\n  margin: 8px 0 0;\n  color: #e20015;\n  font-size: 12px;\n}\n\n.rulesFieldError .containerErro {\n  min-height: 32px;\n  font-size: 12px;\n}\n\n.rulesSaveMessage {\n  margin-top: 18px;\n  padding: 10px 12px;\n  border-left: 4px solid #00884a;\n  background: #e5f4eb;\n  color: #000;\n  font-size: 13px;\n}\n\n.rulesFormActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 24px;\n}\n\n.rulesCancelButton,\n.rulesSaveButton {\n  min-width: 120px;\n  min-height: 50px;\n  justify-content: center;\n}\n\n@media (max-width: 700px) {\n  .rulesFieldHeader {\n    align-items: flex-start;\n  }\n\n  .rulesRequiredBadge {\n    display: none;\n  }\n\n  .rulesFieldHeaderActions {\n    display: none;\n  }\n\n  .rulesFieldBody {\n    margin-left: 0;\n  }\n\n  .rulesTextInput,\n  .rulesCenterAutocomplete {\n    min-width: 100%;\n  }\n\n  .rulesAddButton,\n  .rulesSelectAll {\n    flex: 1 1 auto;\n  }\n\n  .rulesFormActions {\n    justify-content: stretch;\n  }\n\n  .rulesCancelButton,\n  .rulesSaveButton {\n    flex: 1 1 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
